import React from "react";
import { LearningActivityCardLink } from "Components/Module/LearningActivityItem/Actions";

const CourseCardActions = ({ readMoreLink, title, languageContext }) => {
  return (
    <>
      <LearningActivityCardLink
        href={readMoreLink}
        title={`${languageContext("readmoreinfo")} ${title}`}
        aria-label={`${languageContext("readmoreCourse")} ${title}`}
      >
        {languageContext("readmore")}
      </LearningActivityCardLink>
    </>
  );
};

export default CourseCardActions;
